export const InStockTableFilterData = [
    {
        "idFromColumnFilter": "materialPriceUnit",
        "id": "materialPriceUnit", "field": "materialOrganizationOption", "field2": "name"
    },
    {
        "idFromColumnFilter": "unit",
        "id": "unit", "field": "name"
    },
    {
        "idFromColumnFilter": "materialPriceUnit",
        "id": "materialPriceUnit", "field": "quantity",
    },
    {
        "idFromColumnFilter": "quantity",
        "id": "quantity",
    },
    {
        "idFromColumnFilter": "amountBasePrice",
        "id": "amountBasePrice",
    },
    {
        "idFromColumnFilter": "amountAlternativePrice",
        "id": "amountAlternativePrice",
    },
]